$(document).ready(function(){

  var burger = document.getElementById("burger");
  burger.addEventListener('click',(e)=>{
    var nav = document.getElementById("nav");
    nav.classList.toggle('open')
    var body = document.getElementsByTagName("body")[0];
    body.classList.toggle('no-scroll')
  })

  $("#scrollTop").on('click', function() {
    $('html, body').animate({
      scrollTop: 0
    }, 1200);
  });

  $(window).on('scroll',function(){

    var offset = $(window).scrollTop();
    if(offset > 100 && $('.header .container').hasClass('reduce') === false){
      $('.header .container').addClass('reduce');
    }else if(offset <= 100 && $('.header .container').hasClass('reduce') === true){
      $('.header .container').removeClass('reduce');
    }

  })

})



// WEBPACK FOOTER //
// ./src/js/index.js